import { Table, useMantineTheme } from '@mantine/core';
import React, { useMemo } from 'react';
import classes from './PoTable.module.css';

interface PoTableProps {
    data: any;
    selectedStyle?: string;
    handleClick?: (styleNo: string) => void;
}

const PoTable: React.FC<PoTableProps> = ({ data, selectedStyle, handleClick }) => {
    const theme = useMantineTheme();
    const getRowClass = (status?: string, isSelected?: boolean) => {
        if (isSelected) {
            return classes.rowSelected;
        }
        
        const normalizedStatus = status?.trim().toLowerCase();

        if (
            normalizedStatus === 'picked' ||
            normalizedStatus === 'picked all' ||
            normalizedStatus === 'picked_all'
        ) {
            return classes.rowPicked;
        }

        if (
            normalizedStatus === 'not found' ||
            normalizedStatus === 'not_found'
        ) {
            return classes.rowNotFound;
        }

        if (
            normalizedStatus === 'restock' ||
            normalizedStatus === 'allocation' ||
            normalizedStatus === 'pending'
        ) {
            return classes.rowPending;
        }

        if (normalizedStatus === 'done') {
            return classes.rowDone;
        }

        return classes.rowDefault;
    };


    return (
        <div>
            {data && (<Table withColumnBorders stickyHeader striped>
                <Table.Thead className={classes.tableHead}>
                    <Table.Tr>
                        <Table.Th style={{ backgroundColor: theme.colors.gray[8] }} >Style No</Table.Th>
                        <Table.Th style={{ backgroundColor: theme.colors.gray[8] }} >Status</Table.Th>
                        {data.length > 0 && data[0].binLocation && <Table.Th style={{ backgroundColor: theme.colors.gray[8] }} >BIN</Table.Th>}
                    </Table.Tr>
                </Table.Thead>
                <Table.Tbody className={classes.tableBody}>
                    {data.map((item: any) => {
                        const isSelected =
                            selectedStyle === item.styleNo;
                        return (<Table.Tr
                            className={getRowClass(
                                item.status,
                                isSelected
                            )}
                            key={item.styleNo}
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleClick && handleClick(item.styleNo)}
                        >
                            <Table.Td>{item.styleNo}</Table.Td>
                            <Table.Td>{item.status}</Table.Td>
                            {data[0].binLocation && <Table.Td>{item.binLocation}</Table.Td>}
                        </Table.Tr>)
                    })}
                </Table.Tbody>
            </Table>)}
        </div>
    )
}

export default PoTable;